export const environment = {
  production: false,
  serverUrl: 'https://devbackdemo.auriscom.com',
  loginUrl: 'https://devbackdemo.auriscom.com/login',
  signUpUrl: 'https://devbackdemo.auriscom.com/signup',
  application: {},
  config: {
    api: false,
    url: './assets/params/json/crud/'
  }
};
